import journeyAwareness from './journeyAwareness';
import productPages from './productPages';

export default function () {
	$(() => {
		journeyAwareness();
		productPages();
	});
}
